/**
 * author: Qian.qianchen 2018-10-31
 * description: 成品稿库-广播电台
 */
'use strict';
angular.module('audioStockModule', ['audioProgressBarModule'])
    . controller('audioStockCtrl', ['$scope', 'globleParamsSet', 'initComDataService', '$stateParams', 'trsHttpService', '$filter', 'resourceCenterService', '$sce', '$q', '$timeout', function($scope, globleParamsSet, initComDataService, $stateParams, trsHttpService, $filter, resourceCenterService, $sce, $q, $timeout) {
        initStatus();
        initData();

        /**
     * [initStatus description] 状态初始化
     * @return {[type]} [description]
     */
        function initStatus() {
            $scope.page = { // 分页信息
                CURRPAGE: 1,
                PAGESIZE: globleParamsSet.setResourceCenterPageSize,
                ITEMCOUNT: 0
            };
            $scope.data = {
                items: [], // 列表数据
                selectedArray: [], // 复选框所选数据
                operFlags: [], // 取签见撤重
                suggestResult: '', // 搜索匹配结果
                suggestContentList: [], // 搜索匹配的内容列表
                itemCounts: 0, // 显示的稿件数量
                playingItem: {}, // 正在播放的音频对象
                isPlaying: false,
                audioObj: {},
                current: '00:00',
                lastAudio: {}
            };
            $scope.params = { // 列表参数
                typeid: 'zyzx',
                serviceid: 'jtcpg',
                modelId: 'findFromNavigation',
                fcode: $stateParams.fcode,
                pageSize: $scope.page.PAGESIZE,
                pageNum: $scope.page.CURRPAGE,
                keyword: {
                    searchType: '0', // 查询类型
                    keywords: '', // 关键词
                    time: '', // 时间范围
                    area: '', // 地域
                    zyzxfield: '', // 主题
                    isOriginal: '', // 是否原创
                    isHead: '', // 是否头版
                    isRead: '', // 是否10w+
                    menuscriptType: '', // 稿件类型
                    timeLength: '0'
                }
            };
            $scope.status = {
                btnShow: false
            };
        }

        /**
     * [initData description] 数据初始化
     * @return {[type]} [description]
     */
        function initData() {
            initDropDown();
            requestData();
        }

        /**
     * [initDropDown description] 下拉框初始化
     * @return {[type]} [description]
     */
        function initDropDown() {
        // 时长字段
            $scope.durationType = {
                data: [{
                    dictName: '全部时长',
                    id: '0'
                },
                {
                    dictName: '1分钟以内',
                    id: '1'
                },
                {
                    dictName: '1-4分钟',
                    id: '2'
                }, {
                    dictName: '4-6分钟',
                    id: '3'
                }, {
                    dictName: '6分钟以上',
                    id: '4'
                }
                ],
                curValue: {
                    dictName: '全部时长',
                    id: '0'
                }
            };
        }

        /**
     * [requestData description]数据请求
     * @return {[type]} [description]
     */
        function requestData() {
            $scope.data.selectedArray = [];
            var params = angular.copy($scope.params);
            params.keyword = JSON.stringify(params.keyword);
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                if (data.result == 'success') {
                    $scope.data.items = data.content;
                    $scope.data.indexName = data.summary_info.indexName;
                    $scope.page.ITEMCOUNT = data.summary_info.ITEMCOUNT;
                }
            });
        }

        /**
     * [selectDoc description] 选择/取消选择稿件对象
     * @param  {[object]} item [description] 稿件对象
     * @return {[type]}      [description]
     */
        $scope.selectDoc = function(item) {
            var index = $scope.data.selectedArray.indexOf(item);
            if (index < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice(index, 1);
            }
        };

        /**
     * [searchWithKeyword description] 搜索
     * @param  {[String]} key   [description] 搜索条件
     * @param  {[String]} value [description] 搜索内容
     * @return {[type]}       [description]
     */
        $scope.searchWithKeyword = function(key, value) {
            if (key == 'time') {
                value = $scope.data.untildate ? $filter('date')($scope.data.fromdate, 'yyyy-MM-dd') + ',' + $filter('date')($scope.data.untildate, 'yyyy-MM-dd') : ''; // $filter('date')($scope.data.fromdate, 'yyyy/MM/dd').toString() ? $filter('date')($scope.data.fromdate, 'yyyy/MM/dd').toString() + "," + $filter('date')($scope.data.untildate, 'yyyy/MM/dd').toString() : "";
            }
            $scope.params.keyword[key] = value;
            $scope.params.pageNum = $scope.page.CURRPAGE = 1;
            $scope.data.items = [];
            requestData();
        };

        /**
     * [pageChanged description] 分页1
     * @return {[type]} [description]
     */
        $scope.pageChanged = function() {
            $scope.params.pageNum = $scope.page.CURRPAGE;
            requestData();
            resourceCenterService.scrollTop($element);
        };

        /**
     * [playAudio description] 音频播放
     * @param  {[object]} item [description] 音频对象
     * @return {[type]}      [description]
     */
        $scope.playAudio = function(item) {
            selectAudio(item).then(function(data) {
                $timeout(function() {audioPlay(data);});
            });
        };

        /**
     * [pauseAudio description] 音频暂停
     * @param  {[object]} item [description] 音频对象
     * @return {[type]}      [description]
     */
        $scope.pauseAudio = function(item) {
            audioPause(item);
        };

        /**
     * [selectAudio description] 选中播放音频对象
     * @param  {[object]} item [description] 音频对象
     * @return {[type]}      [description]
     */
        function selectAudio(item) {
            let deffer = $q.defer();
            $scope.data.playingItem = item;
            deffer.resolve(item);
            return deffer.promise;
        }

        /**
     * [audioPlay description] 音频播放
     * @param  {[object]} item [description] 音频对象
     * @return {[type]}      [description]
     */
        function audioPlay(item) {
            if (!isEmptyObject($scope.data.lastAudio)) {
                $scope.data.lastAudio.pause();
            }
            if ($scope.data.audioObj.length > 0) {
                $scope.data.audioObj.removeEventListener('timeupdate', showTime);
            }
            $scope.data.audioObj.play();
            $scope.data.isPlaying = true;
            $scope.data.lastAudio = $scope.data.audioObj;
            timeUpdate();
        }

        /**
     * [audioPause description] 音频暂停
     * @param  {[object]} item [description] 音频对象
     * @return {[type]}      [description]
     */
        function audioPause(item) {
            $scope.data.audioObj.pause();
            $scope.data.isPlaying = false;
        }

        /**
     * 音频标签-时间更新事件监听
     */
        function timeUpdate() {
            $scope.data.audioObj.addEventListener('timeupdate', showTime, true);
        }

        /**
     * [showTime description] 音频播放时间更新
     * @return {[type]} [description]
     */
        function showTime() {
            $scope.data.current = timeFormat($scope.data.audioObj.currentTime);
            if ($scope.data.audioObj.currentTime == $scope.data.audioObj.duration) {
                $scope.data.isPlaying = false;
                $scope.data.audioObj.currentTime = 0;
            }
        }

        /**
     * [timeFormat description] 时间格式化
     * @param  {[Number]} seconds [description] 时间（秒）
     * @return {[type]}         [description]
     */
        function timeFormat(seconds) {
            let minute = parseInt(seconds / 60);
            let second = parseInt(seconds - minute * 60);
            if (minute > 0 && minute < 10) {
                minute = '0' + minute;
            } else if (minute <= 0) {
                minute = '00';
            }
            if (second > 0 && second < 10) {
                second = '0' + second;
            } else if (second <= 0) {
                second = '00';
            }
            return minute + ':' + second;
        }

        /**
     * [selectAll description] 全选
     * @return {[type]} [description]
     */
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
        };

        /**
     * [urlFormat description] 音频地址格式化
     * @param  {[object]} item [description] 音频对象
     * @return {[type]}      [description]
     */
        $scope.urlFormat = function(item) {
            let url = $sce.trustAsResourceUrl(item.PUBLIC_URL);
            item.value = {
                'streamsMap': {
                    'l': {
                        'httpURL': url
                    }
                }
            };
        };

        /**
     * [audioIdFormat description] 音频id拼接
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
        $scope.audioIdFormat = function(item) {
            return 'audio-' + item.PUBLIC_ID;
        };

        /**
     * [initAudioObj description] 音频对象初始化
     * @param  {[object]} item [description] 音频对象
     * @return {[type]}      [description]
     */
        $scope.initAudioObj = function(item) {
            $scope.data.audioObj = $('audio')[0];
            $scope.data.audioObj.load();
        };

        /**
     * [downloadAudio description] 音频
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
        $scope.downloadAudio = function(item) {
            var triggerDownload = $('<a>')
                .attr('target', '_blank')
                .attr('href', item.value.streamsMap.l.httpURL + '?attname=' + item.DOCTITLE)
                .attr('download', item.DOCTITLE)
                .appendTo('body');
            triggerDownload[0].click();
            triggerDownload.remove();
        };

        /**
     * [isEmptyObject description] 判断对象是否为空
     * @param  {[type]}  obj [description]对象
     * @return {Boolean}     [description]
     */
        function isEmptyObject(obj) {
            for (var key in obj) {
                return false;
            }
            return true;
        }

        /**
         * [openPageForSearch description] 打开高级检索新页面
         * @return {[date]} [description]
         */
        $scope.openPageForSearch = function() {
            var url = $state.href('resadvancedsearch');
            window.open(url, '_blank');
        };
    }]);
